import React, { useEffect, useState } from "react";
import ShimmerScreen from "../../Layouts/ShimmerScreen";

import _ from "lodash";
import BannerSectionProvider from "../../BannerSectionProvider";
import TitleTagsComponent from "../Misc/TitleTags/TitleTagsComponent";
import ErrorSection from "../../ErrorPage/ErrorSection";

function PartnerDetailSection(props) {
  const [partnerDetail, setPartnerDetail] = useState(props.partnerDetail);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    setIsLoading(true);
    setPartnerDetail(props.partnerDetail);
    setIsLoading(false);
  }, [props.isLoading, props.partnerDetail]);

  // console.log("menu_data", partnerDetail?.menu_data, partnerDetail);
  // const updatedItems = partnerDetail?.menu_data?.map((item) =>
  //   item === "learningpath" ? "Action Path" : item
  // );

  return (
    <div>
      {!_.isEmpty(partnerDetail) ? (
        <>
          {isLoading ? (
            <div className="shimmer-img">
              <ShimmerScreen
                case="rect"
                width="100%"
                height="3rem"
                borderRadius="10px"
              />
            </div>
          ) : (
            <div className="smallbanner-sec">
              {props?.partnerDetail?.provider_id ? (
                <BannerSectionProvider
                  providerId={props?.partnerDetail?.provider_id}
                />
              ) : (
                ""
              )}
            </div>
          )}
          {isLoading ? (
            <div className="shimmer-img mt-3">
              <ShimmerScreen
                case="rect"
                width="10%"
                height="1rem"
                borderRadius="10px"
              />
            </div>
          ) : (
            <h2 className="mgt30">
              <div
                className=""
                dangerouslySetInnerHTML={{
                  __html: partnerDetail?.display_name,
                }}
              ></div>
            </h2>
          )}
          {isLoading && false ? (
            " "
          ) : false && partnerDetail.menu_data ? (
            <div className="detailpage-tags">
              <TitleTagsComponent
                tagsArray={partnerDetail.menu_data}
                isLoading={isLoading}
              />
            </div>
          ) : (
            ""
          )}
          {isLoading ? (
            <div className="shimmer-img mt-3">
              <ShimmerScreen
                case="rect"
                width="100%"
                height="1rem"
                borderRadius="10px"
              />
            </div>
          ) : (
            <ul className="lc-listt-row">
              {partnerDetail.menu_data != undefined &&
                partnerDetail.menu_data.length > 0 &&
                partnerDetail.menu_data?.map((item, index) => {
                  <li key={index}>{item}</li>;
                })}
            </ul>
          )}
          {/* <span className="subheading-row">alpharealestate.com</span> */}
          {isLoading ? (
            <div className="shimmer-img mt-3">
              <ShimmerScreen
                case="rect"
                width="100%"
                height="1rem"
                borderRadius="10px"
              />
            </div>
          ) : (
            <div className="inner-cont">
              <div
                className="disc-content"
                dangerouslySetInnerHTML={{
                  __html: partnerDetail.description,
                }}
              ></div>
            </div>
          )}
        </>
      ) : (
        <ErrorSection />
      )}
    </div>
  );
}

export default PartnerDetailSection;
